<template>
  <a
    href="https://t.me/info_profitads"
    target="_blank"
    class="animation-wrapper"
    :class="{ 'is-expanded': isExanded }"
  >
    <div class="telegram-outside-link__wrap">
      <transition name="expand">
        <img
          @click.prevent="close"
          class="close-icon"
          src="../../assets/icons/icon-small-cross.svg"
          alt="close icon"
        />
      </transition>
      <div class="telegram-outside-link__content">
        <p class="outside-link-first">{{ $t('linkElement.text1') }}</p>
        <transition name="expand">
          <p class="outside-link-second">Напиши нам в <span class="telegram">телеграм.</span></p>
        </transition>
      </div>
    </div>
    <transition name="expand">
      <div class="telegram-outside-link__dont-show">
        <div class="line"></div>
        <span @click.prevent="dontShow" class="telegram-outside-link__text"
          >Больше не показывать</span
        >
      </div>
    </transition>
  </a>
</template>

<script>
export default {
  name: 'WidgetLinkElement',
  props: {
    isExpand: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  data() {
    return {
      isExanded: false,
    };
  },
  methods: {
    dontShow() {
      this.$emit('dontShow');
    },
    close() {
      this.$emit('close');
    },
  },
  mounted() {
    setTimeout(() => {
      this.isExanded = true;
    }, 1000);
  },
};
</script>

<style scoped lang="scss">
@import '@/assets/styles/helpers/variables';

.animation-wrapper {
  transition: height 1s ease;
  height: 50px;
}
.animation-wrapper.is-expanded {
  height: 140px;
}

.expand-enter-active,
.expand-leave-active {
  transition: all 0.7s ease;
}
.expand-enter,
.expand-leave-to {
  transform: scale(0);
  opacity: 0;
}

.outside-link {
  width: 100%;
  padding: 16px;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  border: 1px solid $primary;
  border-radius: 8px;

  &__content {
    display: flex;
    flex-direction: column;
    font-style: normal;
    font-weight: 500;
    font-size: 16px;
    line-height: 24px;
    color: $primary;
    margin-left: 1.6rem;
  }
}
.line {
  width: 100%;
  height: 1px;
  opacity: 0.5;
  background: #d1d4d8;
}
.close-icon {
  position: absolute;
  top: 0;
  right: 0;
}
.telegram-outside-link {
  display: flex;
  flex-direction: column;
  width: 100%;
  max-width: 329px;
  max-height: 150px;
  background-color: var(--primary);
  box-shadow: 0px 14px 32px 0px rgba(5, 6, 8, 0.08);
  &__wrap {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    position: relative;
  }
  &__dont-show {
    width: 100%;
    display: flex;
    flex-direction: column;
    padding-top: 2rem;
    gap: 2rem;
  }
  &__text {
    color: #fff;
    text-decoration: underline;
    font-size: 12px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
    text-decoration-line: underline;
  }
  padding: 16px;
  border: 1px solid var(--primary);
  border-radius: 8px;

  .outside-link-first {
    font-weight: 400;
    font-size: 16px;
    line-height: 100%;
    margin-bottom: 1.1rem;
  }

  .outside-link-second {
    font-size: 14px;
  }

  &__content {
    display: flex;
    flex-direction: column;
    font-style: normal;
    font-weight: 500;
    font-size: 16px;
    line-height: 24px;
    color: #fff;
    .outside-link-second {
      .telegram {
        text-decoration: underline;
      }
    }
  }
}
// .app-sidebar__link {
//     margin-top: 2rem;
//     margin-bottom: -6rem;
//   }
</style>
